import React from 'react';
import { DatePicker } from 'antd';
import { show } from '@xbcb/ui-utils';
import { StyledFormItem } from './styles';
import { CssSize, NamePath } from '@xbcb/ui-types';
import { FormInstance } from 'antd/lib/form';

const { MonthPicker } = DatePicker;

export interface PickDateProps {
  disabled?: boolean;
  disabledDate?: (date: any) => boolean;
  fullNamePath: NamePath;
  localNamePath: NamePath;
  form: FormInstance;
  hideLabel?: boolean;
  label?: string;
  monthOnly?: boolean;
  onChange?: Function;
  readOnly?: boolean;
  required?: boolean;
  $itemSize?: CssSize;
  removeSpaceBottom?: boolean;
  format?: string;
  dataCy?: string;
}

const PickDate: React.FC<PickDateProps> = ({
  dataCy,
  disabled,
  disabledDate,
  fullNamePath,
  localNamePath,
  form,
  hideLabel,
  label,
  monthOnly,
  onChange,
  readOnly,
  required,
  $itemSize = CssSize.TINY_SHORT,
  removeSpaceBottom,
  format,
}) => {
  const Component = monthOnly ? MonthPicker : DatePicker;

  if (!show({ readOnly, form, field: fullNamePath })) return null;

  return (
    <StyledFormItem
      $itemSize={$itemSize}
      $removeSpaceBottom={removeSpaceBottom}
      $inline
      label={hideLabel ? '' : label}
      name={localNamePath}
      rules={[{ required, message: ' ' }]}
      $readOnly={readOnly}
    >
      <Component
        disabled={disabled}
        disabledDate={disabledDate}
        onChange={(date) => {
          if (onChange) onChange(date);
        }}
        format={format}
        data-cy={dataCy}
      />
    </StyledFormItem>
  );
};

export default PickDate;
